export interface ShoppingListFormValues {
  listName: string;
  owner: string;
  glCode: string;
}

export type ShoppingListFormField = keyof ShoppingListFormValues;

export const initialShoppingListFormValues: ShoppingListFormValues = {
  listName: '',
  owner: '',
  glCode: '',
};
  